import { PDPA_INDUSTRIES, PDPA_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type PdpaQA = WaveQA;

export const PDPA_REVIEWED_TH = "สิงหาคม 2569";
export const PDPA_REVIEWED_ISO = "2026-08-07";

export const PDPA_QA: PdpaQA[] = buildLegalClusterQA({
  prefix: "pdpa",
  clusterTh: "งานคุ้มครองข้อมูลส่วนบุคคล (PDPA)",
  authorityTh: "สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.)",
  reviewedTh: PDPA_REVIEWED_TH,
  volatileNote:
    "ประกาศและแนวปฏิบัติภายใต้ พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล ปรับปรุงได้ ควรยืนยันกับ สคส. หรือที่ปรึกษากฎหมายก่อนนำไปใช้",
  topics: toAxis(PDPA_SERVICES),
  extraTopics: toAxis(PDPA_INDUSTRIES, "ind"),
});

export const PDPA_QA_BY_SLUG: Record<string, PdpaQA> = Object.fromEntries(
  PDPA_QA.map((qa) => [qa.slug, qa]),
);

export const PDPA_QA_COUNT = PDPA_QA.length;
